<template>
    <div class="cover">
        <project-cover-title :project="project" />
        <figure class="wrapper">
            <project-cover-media ref="media" :project="project" />
            <project-cover-caption :project="project" />
        </figure>
    </div>
</template>

<script>
import ProjectCoverCaption from "@/components/ProjectCoverCaption";
import ProjectCoverMedia from "@/components/ProjectCoverMedia";
import ProjectCoverTitle from "@/components/ProjectCoverTitle";
import { clearScroll, scroll } from "@/services/scroll.animation";
import { animationCover } from "@/utils/animation.util";

export default {
    components: { ProjectCoverCaption, ProjectCoverMedia, ProjectCoverTitle },
    props: {
        project: {
            type: Object,
            required: true,
        },
        reverse: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        id() {
            return `project-${this.project.id}`;
        },
        videos() {
            return this.project.medias.filter(
                (media) => media.project_media_id.media
            );
        },
        elements() {
            return {
                decoration: this.$el.querySelector(".decoration"),
                frame: this.$el.querySelector(".frame"),
                title: this.$el.querySelector(".title"),
                summary: this.$el.querySelector(".summary"),
            };
        },
    },
    mounted() {
        scroll(
            this.id,
            this.$el,
            this.project.colors,
            animationCover({
                elements: this.elements,
                reverse: this.reverse,
                onCompleteShow: () => {
                    this.$refs.media.play();
                },
                onCompleteHide: () => {
                    this.$refs.media.pause();
                },
            })
        );
    },
    beforeDestroy() {
        clearScroll(this.id);
    },
};
</script>

<style scoped lang="sass">
@import ~include-media/dist/include-media
@import ~styles/base

.cover
    min-height: 70vh
    +media('<small')
        padding-top: var(--line-base)
        padding-bottom: var(--line-base)

    +media('>=small')
        display: grid
        grid-auto-rows: max-content
        min-height: 100vh

.wrapper
    margin: calc(var(--line-base) * 1.5) 0 0

    +media('>=large')
        grid-area: 2 / 1 / 3 / 3
        display: flex
        align-items: flex-start
        margin: 0

+media('>=small')
    .cover
        &:nth-child(odd)
            grid-template-columns: 2fr 1fr

        &:nth-child(even)
            grid-template-columns: 1fr 2fr
            .wrapper
                flex-direction: row-reverse
</style>
